<div class="row">
  <div class="col">
    <div class="jumbotron" style="padding-top: 0px; padding-bottom: 0px;">
      <h1 class="display-4">{{'event.statistic.pageTitle' | translate}}</h1>
      <p class="lead">{{'event.statistic.pageSubTitle' | translate}}</p>
      <hr class="my-4">
    </div>
  </div>
</div>
<div class="searchbar">
  <h3 style="color: #2ba8e3!important; font-weight:bold; text-align: center;">
    {{'event.statistic.filters' | translate}}
  </h3>
  <h4 class="mt-0 mb-3">{{'event.statistic.filtersDescription' | translate}}</h4>
  <div class="searchcontent">
    <div class="filters">
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.selectionDateRange' | translate}}</div>
        <div class="col-12 input">
          <kendo-daterange>
            <kendo-dateinput
              kendoDateRangeStartInput
              autoCorrectOn="blur"
              [(value)]="selectionDateRange.start"
              [format]="'dd-MM-yyyy'"
              [min]="eventStartDate"
              [readonly]="true"
              style="width:46%; margin:0 2%;"
            ></kendo-dateinput>
            <kendo-dateinput
              kendoDateRangeEndInput
              autoCorrectOn="blur"
              [(value)]="selectionDateRange.end"
              [format]="'dd-MM-yyyy'"
              [max]="eventEndDate"
              [readonly]="true"
              style="width:46%; margin:0 2%;"
            ></kendo-dateinput>
            <kendo-daterange-popup
              [animate]="true"
            ></kendo-daterange-popup>
          </kendo-daterange>
        </div>
      </div>
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.selectionTimeRange' | translate}}</div>
        <div class="col-12 input">
          <kendo-timepicker
            [(value)]="selectionTimeRange.start"
            format="HH:mm"
            style="width:46%; margin:0 2%;"
          ></kendo-timepicker>
          <kendo-timepicker
            [(value)]="selectionTimeRange.end"
            format="HH:mm"
            style="width:46%; margin:0 2%;"
          ></kendo-timepicker>
        </div>
      </div>
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.selectPricelists' | translate}}</div>
        <div class="col-12 input">
          <kendo-dropdownlist
            [data]="allPriceLists"
            textField="name"
            valueField="id"
            [(ngModel)]="selectedPriceList"
          ></kendo-dropdownlist>
        </div>
      </div>
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.showCharts' | translate}}</div>
        <div class="col-12 input" style="text-align:center">
          <kendo-switch
            [(ngModel)]="showChartChecked"
            onLabel= "{{'event.statistic.showChartYes' | translate}}"
            offLabel= "{{'event.statistic.showChartNo' | translate}}"
          ></kendo-switch>
        </div>
      </div>
  </div>
    <div class="filters mt-4">
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.selectDeviceType' | translate}}</div>
        <div class="col-12 input">
          <kendo-dropdownlist
            [data]="allDeviceTypes"
            textField="name"
            valueField="id"
            [value]="selectedDeviceType"
            (selectionChange)="onSelectDeviceType($event)"
          ></kendo-dropdownlist>
        </div>
      </div>
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.selectDevice' | translate}}</div>
        <div class="col-12 input">
          <kendo-multiselect
            [data]="allDevices"
            textField="name"
            valueField="id"
            [value]="selectedDevicesEmpty ? null : selectedDevices"
            (valueChange)="onSelectDevice($event)"
          ></kendo-multiselect>
        </div>
      </div>
      <div class="filter">
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">{{'event.statistic.selectTable' | translate}}</div>
        <div class="col-12 input">
          <kendo-multiselect
            [data]="allTables"
            textField="name"
            valueField="id"
            [value]="selectedTablesEmpty ? null : selectedTables"
            (valueChange)="onSelectTable($event)"
          ></kendo-multiselect>
        </div>
      </div>
      <div class="filter" *ngIf="showStatistic" >
        <div class="col-12 box-title" style="font-weight:bold; text-align:center; font-size: 15px; padding: 7px 10px">&nbsp;</div>
        <div class="col-12 input" style="text-align:center">
          <button kendoButton (click)="onDeleteButtonClick()"
                  size="medium"
                  shape="rectangle"
                  rounded="medium"
                  fillMode="solid"
                  themeColor="error"
                  style="margin:0 10px"
          >{{'event.statistic.deleteDataSwitcherLabel' | translate}}</button>
        </div>
      </div>
    </div>
    <div class="buttons row" style="margin:20px 0; justify-content: center">
      <div style="display: flex; justify-content: center; flex-wrap: wrap; width: 100%">
        <button kendoButton (click)="onSearchButtonClick()"
                size="large"
                themeColor="primary"
                style="width: 150px; margin: 10px"
        >{{'event.statistic.search' | translate}}</button>
        <button kendoButton (click)="onResetButtonClick()"
                size="large"
                themeColor="secondary"
                style="width: 150px; margin: 10px"
        >{{'event.statistic.reset' | translate}}</button>
        <button kendoButton icon="file-excel" (click)="save(excelexport2, excelexport3, excelexport1)"
                size="large"
                themeColor="success"
                style="width: 150px; margin: 10px"
        >{{'event.statistic.export' | translate}}</button>
        <button kendoButton icon="print" (click)="router.navigate(['event/details', event.id, 'delivery-paper'])"
                size="large"
                themeColor="tertiary"
                style="width: 150px; margin: 10px"
        >{{'event.statistic.deliveryPaper' | translate}}</button>
      </div>
    </div>
      @if (missingDataWarning) {
        <div style="background-color: orange; text-align: center; font-size: medium; width: 50%; height: 30px; justify-self: center">Missing Data Warning</div>
      }
      <div>
      <div>
        <kendo-excelexport
          [data]="statisticTurnoverData?.sales.tables"
          [collapsible]="true"
          fileName="{{event.eventName}} {{selectionDateRange.start | date: 'dd/MM/yyyy'}} - {{selectionDateRange.end | date: 'dd/MM/yyyy'}}.xlsx"
          #excelexport1
        >
          <kendo-excelexport-column
            field="name"
            title="{{'event.statistic.tables' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="amount"
            title="{{'event.statistic.amount' | translate}} ({{eventCurrency}})"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="quantity"
            title="{{'event.statistic.tablesQuantity' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          </kendo-excelexport>
          <kendo-excelexport
            [data]="exportProductsData"
            fileName="{{event.eventName}} {{selectionDateRange.start | date: 'dd/MM/yyyy'}} - {{selectionDateRange.end | date: 'dd/MM/yyyy'}}.xlsx"
            #excelexport2
          >
            <kendo-excelexport-column
              field="product"
              title="{{'event.statistic.productName' | translate}}"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="productInfo"
              title="{{'event.statistic.productInfo' | translate}}"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="categoryName"
              title="{{'event.statistic.categoryName' | translate}}">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="productPrice"
              title="{{'event.statistic.productPrice' | translate}} ({{eventCurrency}})"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="amountPaid"
              title="{{'event.statistic.amount' | translate}} ({{eventCurrency}})"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="quantityPaid"
              title="{{'event.statistic.quantity' | translate}}"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="amountFree"
              title="{{'event.statistic.amountFree' | translate}} ({{eventCurrency}})"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="quantityFree"
              title="{{'event.statistic.quantityFree' | translate}}"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="amountCancelled"
              title="{{'event.statistic.amountCancelled' | translate}} ({{eventCurrency}})"
              [width]="150">
            </kendo-excelexport-column>
            <kendo-excelexport-column
              field="quantityCancelled"
              title="{{'event.statistic.quantityCancelled' | translate}}"
              [width]="150">
            </kendo-excelexport-column>
        </kendo-excelexport>
        <kendo-excelexport
          [data]="exportWaitersData"
          fileName="{{event.eventName}} {{selectionDateRange.start | date: 'dd/MM/yyyy'}} - {{selectionDateRange.end | date: 'dd/MM/yyyy'}}.xlsx"
          #excelexport3>
          <kendo-excelexport-column
            field="waiter"
            title="{{'event.statistic.waiter' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="product"
            title="{{'event.statistic.productName' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="productInfo"
            title="{{'event.statistic.productInfo' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="categoryName"
            title="{{'event.statistic.categoryName' | translate}}">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="productPrice"
            title="{{'event.statistic.productPrice' | translate}} ({{eventCurrency}})"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="amountPaid"
            title="{{'event.statistic.amount' | translate}} ({{eventCurrency}})"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="quantityPaid"
            title="{{'event.statistic.quantity' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="amountFree"
            title="{{'event.statistic.amountFree' | translate}} ({{eventCurrency}})"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="quantityFree"
            title="{{'event.statistic.quantityFree' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="amountCancelled"
            title="{{'event.statistic.amountCancelled' | translate}} ({{eventCurrency}})"
            [width]="150">
          </kendo-excelexport-column>
          <kendo-excelexport-column
            field="quantityCancelled"
            title="{{'event.statistic.quantityCancelled' | translate}}"
            [width]="150">
          </kendo-excelexport-column>
        </kendo-excelexport>
      </div>
    </div>
  </div>
</div>
<div #printableArea>
<div class="row" style="margin:25px 0;" *ngIf="showStatistic">
  <div class="col-12">
    <div class="card-group">
      <div class="card border">
        <div class="card-body text-center">
          <div class="row" style="justify-content: center;">
            <div style="margin-left: 50px; margin-right: 50px">
              <h5 class="card-title"><strong>{{'event.statistic.salesLabel' | translate}}</strong></h5>
              <p class="card-text form-text text-muted">{{  eventTotalTurnover | number : '1.2-2' }} {{eventCurrency}}</p>
            </div>
            <div style="margin-left: 50px; margin-right: 50px">
              <h5 class="card-title"><strong>{{'event.statistic.salesFreeLabel' | translate}}</strong></h5>
              <p class="card-text form-text text-muted">{{  eventFreeTurnover | number : '1.2-2' }} {{eventCurrency}}</p>
            </div>
            <div style="margin-left: 50px; margin-right: 50px">
              <h5 class="card-title"><strong>{{'event.statistic.salesDeletedLabel' | translate}}</strong></h5>
              <p class="card-text form-text text-muted">{{  eventDeletedTurnover | number : '1.2-2' }} {{eventCurrency}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card border">
        <div class="card-body text-center">
          <div class="row" style="justify-content: center">
            <div style="margin-left: 80px; margin-right: 80px">
              <h5 class="card-title"><strong>{{'event.statistic.ordersLabel' | translate}}</strong></h5>
              <p class="card-text form-text text-muted">{{ allOrders.length - cancelledOrders }}</p>
            </div>
            <div style="margin-left: 80px; margin-right: 80px">
              <h5 class="card-title"><strong>{{'event.statistic.salesDeletedLabel' | translate}}</strong></h5>
              <p class="card-text form-text text-muted">{{ cancelledOrders}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="showStatistic && showChartChecked" style="margin-right: 0; margin-left: 0; padding-left: 10px; padding-right: 10px; background-color: white;">
  @if (highCategoryCount) {
    <kendo-chart #salesCategoryChart class="w-100" style="height: 500px;">
      <kendo-chart-title text="{{'event.statistic.salesCategory' | translate}}"></kendo-chart-title>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item>
          <kendo-chart-value-axis-item-title
            [text]="('event.statistic.amount' | translate) + ' (' + eventCurrency + ')'"></kendo-chart-value-axis-item-title>
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item
          [categories]="salesCategoriesSortedArr"
          categoryField="name">
          <kendo-chart-category-axis-item-labels
            rotation="30">
          </kendo-chart-category-axis-item-labels>
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="column"
          [data]="salesCategoriesSortedArr"
          categoryField="name"
          field="amount">
          <kendo-chart-series-item-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value">
              {{ 'event.statistic.orders' | translate }}: {{ value | currency : '':''}} {{eventCurrency}}
            </ng-template>
          </kendo-chart-series-item-tooltip>
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  }
  @if (highCategoryFreeCount) {
    <kendo-chart #freeCategoryChart class="w-100" style="height: 500px;">
      <kendo-chart-title text="{{'event.statistic.freeCategory' | translate}}"></kendo-chart-title>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item>
          <kendo-chart-value-axis-item-title
            [text]="('event.statistic.amount' | translate) + ' (' + eventCurrency + ')'"></kendo-chart-value-axis-item-title>
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item
          [categories]="salesCategoriesFreeSortedArr"
          categoryField="name">
          <kendo-chart-category-axis-item-labels
            rotation="30">
          </kendo-chart-category-axis-item-labels>
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="column"
          [data]="salesCategoriesFreeSortedArr"
          categoryField="name"
          field="amount">
          <kendo-chart-series-item-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value">
              {{ 'event.statistic.orders' | translate }}: {{ value | currency : '':''}} {{eventCurrency}}
            </ng-template>
          </kendo-chart-series-item-tooltip>
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  }
  @if (highCategoryCancelledCount) {
    <kendo-chart #cancelledCategoryChart class="w-100" style="height: 500px;">
      <kendo-chart-title text="{{'event.statistic.cancelledCategory' | translate}}"></kendo-chart-title>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item>
          <kendo-chart-value-axis-item-title
            [text]="('event.statistic.amount' | translate) + ' (' + eventCurrency + ')'"></kendo-chart-value-axis-item-title>
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item
          [categories]="salesCategoriesCancelledSortedArr"
          categoryField="name">
          <kendo-chart-category-axis-item-labels
            rotation="30">
          </kendo-chart-category-axis-item-labels>
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="column"
          [data]="salesCategoriesCancelledSortedArr"
          categoryField="name"
          field="amount">
          <kendo-chart-series-item-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value">
              {{ 'event.statistic.orders' | translate }}: {{ value | currency : '':''}} {{eventCurrency}}
            </ng-template>
          </kendo-chart-series-item-tooltip>
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  }
  @if (!highCategoryCount && statisticTurnoverData.sales.categories.length > 0) {
    <kendo-chart #salesCategoryChart [ngStyle]="((statisticTurnoverData.sales.categoriesFree.length > 0 && statisticTurnoverData.sales.categoriesCancelled.length > 0) || (statisticTurnoverData.sales.categoriesFree.length === 0 && statisticTurnoverData.sales.categoriesCancelled.length === 0)) && {'width': '100%'}" title="{{'event.statistic.salesCategory' | translate}}">
      <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="pie"
          field="amount"
          categoryField="name"
          [data]="statisticTurnoverData.sales.categories"
          [labels]="{ visible: true, content: amountContent }">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  }
  @if (!highCategoryFreeCount) {
    <kendo-chart *ngIf="statisticTurnoverData.sales.categoriesFree.length > 0" [ngStyle]="(highCategoryCancelledCount || (statisticTurnoverData.sales.categoriesCancelled.length <= 0 && highCategoryCount)) && {'width': '100%'}" #freeCategoryChart title="{{'event.statistic.freeCategory' | translate}}">
      <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      <kendo-chart-series>
        <kendo-chart-series-item
        type="pie"
        field="amount"
        categoryField="name"
        [data]="statisticTurnoverData.sales.categoriesFree"
        [labels]="{ visible: true, content: amountContent }">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  }
  @if (!highCategoryCancelledCount) {
    <kendo-chart *ngIf="statisticTurnoverData.sales.categoriesCancelled.length > 0" [ngStyle]="(highCategoryFreeCount || (statisticTurnoverData.sales.categoriesFree.length <= 0 && highCategoryCount)) && {'width': '100%'}" #cancelledCategoryChart title="{{'event.statistic.cancelledCategory' | translate}}">
      <kendo-chart-legend [visible]="false">
        <kendo-chart-series>
          <kendo-chart-series-item
          type="pie"
          field="amount"
          categoryField="name"
          [data]="statisticTurnoverData.sales.categoriesCancelled"
          [labels]="{ visible: true, content: amountContent }">
          </kendo-chart-series-item>
        </kendo-chart-series>
      </kendo-chart-legend>
    </kendo-chart>
  }
</div>
<div class="d-flex flex-wrap" *ngIf="showStatistic && showChartChecked && statisticTurnoverData.sales.devices?.length > 0">
  @if (highDeviceCount) {
    <kendo-chart #salesDeviceChart class="w-100" style="height: 500px;">
      <kendo-chart-title text="{{'event.statistic.salesDevice' | translate}}"></kendo-chart-title>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item>
          <kendo-chart-value-axis-item-title
            [text]="('event.statistic.amount' | translate) + ' (' + eventCurrency + ')'">
          </kendo-chart-value-axis-item-title>
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item
          [categories]="salesAmountDeviceSortedArr"
          categoryField="name">
          <kendo-chart-category-axis-item-labels
            rotation="30">
          </kendo-chart-category-axis-item-labels>
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="column"
          [data]="salesAmountDeviceSortedArr"
          categoryField="name"
          field="amount">
          <kendo-chart-series-item-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value">
              {{ 'event.statistic.orders' | translate }}: {{ value | currency : '':''}} {{eventCurrency}}
            </ng-template>
          </kendo-chart-series-item-tooltip>
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
    <kendo-chart #qtyDeviceChart class="w-100" style="height: 500px;">
      <kendo-chart-title text="{{'event.statistic.qtyOrdersDevice' | translate}}"></kendo-chart-title>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item>
          <kendo-chart-value-axis-item-title
            [text]="('event.statistic.quantity' | translate)">
          </kendo-chart-value-axis-item-title>
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item
          [categories]="salesDeviceSortedArr"
          categoryField="name">
          <kendo-chart-category-axis-item-labels
            rotation="30">
          </kendo-chart-category-axis-item-labels>
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="column"
          [data]="salesDeviceSortedArr"
          categoryField="name"
          field="quantity">
          <kendo-chart-series-item-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value">
              {{ 'event.statistic.orders' | translate }}: {{value}}
            </ng-template>
          </kendo-chart-series-item-tooltip>
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  } @else {
    @if (getFilteredSalesAmounts().length > 0) {
      <kendo-chart #salesDeviceChart class="pl-0" title="{{'event.statistic.salesDevice' | translate}}">
        <kendo-chart-legend [visible]="false"></kendo-chart-legend>
        <kendo-chart-series>
          <kendo-chart-series-item
            type="pie"
            field="amount"
            categoryField="name"
            [data]="getFilteredSalesAmounts()"
            [labels]="{visible: true, content: amountContent}">
          </kendo-chart-series-item>
        </kendo-chart-series>
      </kendo-chart>
    }
    <kendo-chart #qtyDeviceChart *ngIf="statisticTurnoverData.sales.devices?.length > 0"
        class="pr-0" title="{{'event.statistic.qtyOrdersDevice' | translate}}" [ngClass]="getFilteredSalesAmounts().length > 0 ? 'w-50' : 'w-100'">
      <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="pie"
          field="quantity"
          categoryField="name"
          [data]="statisticTurnoverData.sales.devices"
          [labels]="{visible: true, content: quantityContent}">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  }
</div>
<div class="p-4 bg-white" *ngIf="showStatistic && showChartChecked">
  <kendo-chart #turnoverChart *ngIf="allOrders?.length > 1" class="w-100"
      [pannable]="{ lock: 'y' }">
    <kendo-chart-title text="{{'event.statistic.turnoverTimeLog'|translate}}"></kendo-chart-title>
    <kendo-chart-value-axis>
      <kendo-chart-value-axis-item
        [title]="{ text: 'event.statistic.tableTurnover' | translate } + eventCurrency"
        [max]="maxTurnover"
      >
      </kendo-chart-value-axis-item>
    </kendo-chart-value-axis>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item
        [categories]="timeTurnoverCategories"
        [max]="40"
        [title]="{ text: 'event.statistic.time' | translate }"
      >
      </kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
    <kendo-chart-series-defaults [highlight]="{inactiveOpacity: 0.3}"></kendo-chart-series-defaults>
    <kendo-chart-series>
      <kendo-chart-series-item
      type="area"
      [data]="turnoverDataRounded">
      <kendo-chart-series-item-tooltip>
        <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category">
          <div>{{ 'event.statistic.salesLabel' | translate }}: {{value | number : '1.2-2'}} {{eventCurrency}} / {{eventTotalTurnover | number : '1.2-2'}} {{eventCurrency}}</div>
        </ng-template>
      </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>
    </kendo-chart-series>
  </kendo-chart>
</div>
<div class="p-4 bg-white" *ngIf="showStatistic && showChartChecked">
  <kendo-chart #ordersChart *ngIf="this.ordersData?.length > 1" class="w-100"
    [pannable]="{ lock: 'y' }">
    <kendo-chart-title text="{{'event.statistic.ordersTimeLog'|translate}}"></kendo-chart-title>
    <kendo-chart-value-axis>
      <kendo-chart-value-axis-item
        [title]="{ text: 'event.statistic.orders' | translate }"
        [max]="maxOrders"
      >
      </kendo-chart-value-axis-item>
    </kendo-chart-value-axis>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item
        [categories]="timeOrdersCategories"
        [max]="40"
        [title]="{ text: 'event.statistic.time' | translate }"
      >
      </kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
    <kendo-chart-series-defaults [highlight]="{inactiveOpacity: 0.3}"></kendo-chart-series-defaults>
    <kendo-chart-series>
      <kendo-chart-series-item
      type="area"
      [data]="ordersDataRounded">
      <kendo-chart-series-item-tooltip>
        <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category">
          <div>{{ 'event.statistic.orders' | translate }}: {{value}} / {{ordersDataTotal}}</div>
        </ng-template>
      </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>
    </kendo-chart-series>
  </kendo-chart>
</div>
<div class="p-4 bg-white" *ngIf="showStatistic && showChartChecked">
  <kendo-chart #salesTablesChart *ngIf="hasWaiters" class="w-100">
    <kendo-chart-title text="{{'event.statistic.salesTables'|translate}}"></kendo-chart-title>
    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
    <kendo-chart-series>
      <kendo-chart-series-item
        [data]="tableStats">
        <kendo-chart-series-item-tooltip>
          <ng-template kendoChartSeriesTooltipTemplate let-value="value">
            {{ 'event.statistic.salesLabel' | translate }}: {{ value | currency : '':''}} {{eventCurrency}}
          </ng-template>
        </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>
    </kendo-chart-series>
    <kendo-chart-value-axis>
      <kendo-chart-value-axis-item
        max="{{tableStatsMaxValue}}"
        [title]="{ text: 'event.statistic.tableTurnover' | translate } + eventCurrency">
      </kendo-chart-value-axis-item>
    </kendo-chart-value-axis>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item
        [title]="{ text: 'event.statistic.tableNumber' | translate}"
        [categories]="tableNumbersStats">
      </kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
  </kendo-chart>
  <div fxLayout="row" fxLayoutAlign="center center" style="justify-content: center; display: flex">
    <button kendoButton [disabled]="tableStatsIsFirstPage" style="margin: 10px" (click)="onStatsPageChange(false)">&#60;</button>
    <div style="padding: 18px">{{ 'event.statistic.page' | translate }} {{tableStatsPage}} {{ 'event.statistic.pageOf' | translate }} {{tableStatsMaxPages}}</div>
    <button kendoButton [disabled]="tableStatsIsLastPage" style="margin: 10px" (click)="onStatsPageChange(true)">></button>
  </div>
</div>
<div class="p-4 bg-white" *ngIf="statisticTurnoverData?.sales.tables?.length > 1">
  <kendo-chart #qtyTablesChart class="w-100">
    <kendo-chart-title text="{{'event.statistic.qtyOrdersTable' | translate}}"></kendo-chart-title>
    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
    <kendo-chart-series>
      <kendo-chart-series-item
        [data]="ordersTable">
        <kendo-chart-series-item-tooltip>
          <ng-template kendoChartSeriesTooltipTemplate let-value="value">
            {{ 'event.statistic.orders' | translate }}: {{ value }}
          </ng-template>
        </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>
    </kendo-chart-series>
    <kendo-chart-value-axis>
      <kendo-chart-value-axis-item
        [title]="{ text: 'event.statistic.orders' | translate }"
        max="{{ordersTableMaxValue}}">
      </kendo-chart-value-axis-item>
    </kendo-chart-value-axis>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item
        [title]="{ text: 'event.statistic.tableNumber' | translate}"
        [categories]="tableNumbersOrders">
      </kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
  </kendo-chart>
  <div fxLayout="row" fxLayoutAlign="center center" style="justify-content: center; display: flex">
    <button kendoButton [disabled]="ordersTableIsFirstPage" style="margin: 10px" (click)="onOrdersPageChange(false)">&#60;</button>
    <div style="padding: 18px">{{ 'event.statistic.page' | translate }} {{ordersTablePage}} {{ 'event.statistic.pageOf' | translate }} {{ordersTableMaxPages}}</div>
    <button kendoButton [disabled]="ordersTableIsLastPage" style="margin: 10px" (click)="onOrdersPageChange(true)">></button>
  </div>
</div>
<kendo-chart #salesProductChart *ngIf="showStatistic && showChartChecked && chartData.products?.length > 0" class="w-100">
  <kendo-chart-title text="{{'event.statistic.salesProduct' | translate}}"></kendo-chart-title>
  <kendo-chart-category-axis>
    <kendo-chart-category-axis-item [categories]="chartData.products.names"></kendo-chart-category-axis-item>
  </kendo-chart-category-axis>
  <kendo-chart-series>
    <kendo-chart-series-item
      type="bar"
      [data]="chartData.products.amounts"
      [color]="'#57c6f2'"
      [gap]="0.8">
      <kendo-chart-series-item-labels [format]="'{0} {{eventCurrency}}'"></kendo-chart-series-item-labels>
    </kendo-chart-series-item>
  </kendo-chart-series>
</kendo-chart>
</div>
<h3 style="color: #2ba8e3!important; text-align: center;"  class="mt-4" *ngIf="showStatistic">{{'event.statistic.resume' | translate}}</h3>
<div class="row mb-4" *ngIf="showStatistic">
  <div class="col">
    <kendo-grid
      [data]="gridData"
      [pageSize]="state.take"
      [skip]="state.skip"
      [sort]="state.sort"
      [filter]="state.filter"
      [sortable]="sortingSettings"
      [pageable]="{
        info: pagingSettings.info,
        type: pagingSettings.type,
        pageSizes: pagingSettings.pageSizes,
        previousNext: pagingSettings.previousNext,
        position: pagingSettings.position
      }"
      [reorderable]="false"
      [resizable]="false"
      [navigable]="true"
      [height]="800"
      filterable="menu"
      [columnMenu]="{ filter: true }"
      (dataStateChange)="dataStateChange($event)"
      [kendoGridExpandDetailsBy]="expandDetailsBy"
      [(expandedDetailKeys)]="expandedDetailKeys"
      (cellClick)="onCellClick($event)"
      (excelExport)="onExcelExport($event)"
    >
      <!-- ------------------ GRID ------------------ -->
      <kendo-grid-column field="order.table" title="{{'event.statistic.table' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="order.createdAt" title="{{'event.statistic.dateLabel' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="deviceUserName" title="{{'event.statistic.deviceUserName' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="deviceType" title="{{'event.statistic.deviceUserType' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="order.fiscalPrinted" title="{{'event.statistic.fiscalPrinted' | translate}}" *ngIf="hasFiscalPrinter"></kendo-grid-column>
      <kendo-grid-column field="order.amount" title="{{'event.statistic.totalAmount' | translate}}" format="{0} {{eventCurrency}}"></kendo-grid-column>
      <div *kendoGridDetailTemplate="let dataItem">
        <app-order-categories [orderCategories]="dataItem.order.orderCategory" [eventCurrency]="eventCurrency"></app-order-categories>
      </div>
    </kendo-grid>
  </div>
</div>
<h3 *ngIf="statisticTurnoverData?.orders?.length === 0" style="text-align: center">{{'event.statistic.noData' | translate}}</h3>
<kendo-dialog
  title="{{'event.statistic.deleteDataDialogTitle' | translate}}"
  *ngIf="dialogOpened"
  (close)="closeDialog(false)"
  [minWidth]="250"
  [width]="450"
  [height]="200"
>
  <p style="margin: 30px; text-align: center;">
    {{'event.statistic.deleteDataMessage' | translate}}
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeDialog(false)">{{'event.statistic.deleteDataNo' | translate}}</button>
    <button kendoButton (click)="closeDialog(true)" themeColor="primary">{{'event.statistic.deleteDataYes' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>
